import './PriorityBadge.css';

export type WorkPriority = 'low' | 'normal' | 'high';

const LABEL: Record<WorkPriority, string> = {
  low: 'Menor',
  normal: 'Normal',
  high: 'Mayor',
};

interface PriorityBadgeProps {
  priority: WorkPriority | undefined;
  label?: string;
  testId?: string;
}

export function PriorityBadge({ priority, label, testId }: PriorityBadgeProps) {
  const p = priority ?? 'normal';
  if (p === 'normal') return null;
  return (
    <span
      className={`priority-badge priority-badge--${p}`}
      role="status"
      data-priority={p}
      data-testid={testId ?? 'priority-badge'}
    >
      {label ?? LABEL[p]}
    </span>
  );
}
